import React from 'react';

import cs from 'classnames';
import { useRecoilValue } from 'recoil';

import DateInputPicker from 'components/shared/DateInputPicker/DateInputPicker';
import { permissions } from 'components/state';

import { dosesList, vaccinesList } from '../../../../../lib/constants/constants';
import Checkbox from '../../../Checkbox/Checkbox';
import Select from '../../../Select/Select';
import Textarea from '../../../Textarea/Textarea';
import { isDataReadOnly } from '../lib/aggregatedDataHelper';

const VaccinesRow = ({
  vaccine,
  doses,
  lastDose,
  newDesign,
  lastDoseDisabled,
  notSure,
  index,
  note,
  id,
  onChange,
  formik,
  onCheckNotSure = () => null,
  className,
  createdBy = null,
  disabled = false
}) => {
  const userPermissions = useRecoilValue(permissions);

  const dataReadOnly = isDataReadOnly({
    data: { id, createdBy },
    canUserUpdatePatientDocuments: userPermissions?.form?.update_patient_documents
  });

  return (
    <div className={cs('flex w-full items-center gap-x-[10px]', className)}>
      <div className="grid w-full items-center gap-4">
        <div
          className={
            newDesign ? 'flex flex-col !gap-4' : 'grid grid-cols-2 items-end gap-4 xl:grid-cols-4'
          }>
          <Select
            inputId="select-vaccine"
            label="Vaccine"
            options={vaccinesList}
            value={vaccine}
            id={'vaccine-' + index}
            name="vaccine"
            error={formik?.errors?.vaccine}
            onChange={(event) => onChange('vaccine', event, id)}
            isCreatable
            placeholder="Type and select vaccine"
            disabled={disabled || dataReadOnly}
          />
          <Select
            inputId="doses-taken"
            label="Doses taken"
            id={'vaccine-doses-' + index}
            options={dosesList}
            value={doses}
            name="doses"
            onChange={(event) => onChange('doses', event, id)}
            placeholder="How many doses?"
            disabled={disabled || dataReadOnly}
          />

          <div className="col-span-2 flex items-end gap-4">
            <DateInputPicker
              label="Date of last dose"
              isDateOnly
              value={lastDose}
              onChange={(val) => onChange('lastDose', val, id)}
              disabled={disabled || lastDoseDisabled || dataReadOnly}
            />

            <Checkbox
              data-qa="not-sure"
              className="!mb-2"
              label="Not sure"
              id={'vaccine-not-' + index}
              name="notSure"
              isChecked={notSure}
              onChange={() => onCheckNotSure(id)}
              disabled={disabled || dataReadOnly}
            />
          </div>
        </div>

        <Textarea
          label="Notes"
          placeholder="Add note here"
          id={'vaccine-note-' + index}
          isEditor={!newDesign}
          data-qa="note"
          className={cs(!newDesign ? '!min-h-[120px]' : '!min-h-[80px]', 'mb-2  text-sm')}
          name="note"
          value={note}
          onChange={
            !newDesign
              ? (value) => onChange('note', value, id)
              : (event) => onChange('note', event.target.value, id)
          }
          transcribing
          disabled={disabled || dataReadOnly}
        />
      </div>
    </div>
  );
};

export default VaccinesRow;
